import { ComponentType, useContext, useEffect, useState } from 'react'
import { AuthContext } from '@/context/authContext'
import { Auth, getAuth } from 'firebase/auth'
import firebaseApp from '@/lib/firebase/firebaseConfig'
import * as Sentry from '@sentry/nextjs'
import { LoginPage } from '@/components/pages/login/LoginPage'

export const withAuthentication = <P extends object>(
  WrappedComponent: ComponentType<P>,
  withLogin: boolean = false,
) => {
  return function AuthenticatedComponent(props: P) {
    const [authReady, setAuthReady] = useState(false)
    const [showLogin, setShowLogin] = useState(false)
    const { user, setUser } = useContext(AuthContext)

    useEffect(() => {
      let auth: Auth
      try {
        auth = getAuth(firebaseApp)
      } catch (error) {
        Sentry.captureException('Firebase initialization error:', error)
        setAuthReady(true) // Set to true to prevent infinite loading
        return
      }

      const unsubscribe = auth.onAuthStateChanged((user) => {
        setUser(user)
        setAuthReady(true)
      })
      return () => unsubscribe()
    }, [user, setUser])

    if (withLogin && !user) {
      return authReady && <LoginPage />
    }

    return authReady && <WrappedComponent {...props} />
  }
}
